import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { LOAD, selectNo } from '@poc-monorepo/shared-state';



@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'main-app';
  private router = inject(Router);
  private keydownHandler: ((event: KeyboardEvent) => void) | null = null;

  constructor() {
    // this.sv.get(environment.baseapi).subscribe()
  }

  ngOnInit() {
    // Hidden keyboard shortcut: Ctrl+Shift+L opens CIS API Log page
    this.keydownHandler = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.shiftKey && event.code === 'KeyL') {
        event.preventDefault();
        this.router.navigate(['/app/cis-api-log']);
      }
    };
    document.addEventListener('keydown', this.keydownHandler);
  }

  ngOnDestroy() {
    if (this.keydownHandler) {
      document.removeEventListener('keydown', this.keydownHandler);
    }
  }

  // buttonState() {
  //   this.store.dispatch(LOAD())
  // }

}
